import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import './Navbar.css';

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    const isActive = (path) => {
        if (path === '/' && location.pathname === '/') return true;
        if (path !== '/' && location.pathname.startsWith(path)) return true;
        return false;
    };

    return (
        <nav className="navbar">
            <div className="container">
                <div className="navbar-content">
                    <Link to="/" className="navbar-logo">
                        <span className="logo-text">Apps</span>
                        <span className="logo-text-accent">logie</span>
                    </Link>

                    <button
                        className={`navbar-toggle ${isOpen ? 'active' : ''}`}
                        onClick={() => setIsOpen(!isOpen)}
                        aria-label="Toggle menu"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                    <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
                        <Link to="/" className={`navbar-link ${isActive('/') ? 'active' : ''}`} onClick={() => setIsOpen(false)}>
                            Home
                        </Link>
                        <Link to="/#apps" className="navbar-link" onClick={() => {
                            setIsOpen(false);
                            setTimeout(() => {
                                const appsSection = document.getElementById('apps');
                                if (appsSection) appsSection.scrollIntoView({ behavior: 'smooth' });
                            }, 0);
                        }}>
                            Our Apps
                        </Link>
                        <Link to="/contact" className={`navbar-link ${isActive('/contact') ? 'active' : ''}`} onClick={() => setIsOpen(false)}>
                            Contact
                        </Link>
                        <Link to="/privacy" className={`navbar-link ${isActive('/privacy') ? 'active' : ''}`} onClick={() => setIsOpen(false)}>
                            Privacy
                        </Link>
                        <Link to="/terms" className={`navbar-link ${isActive('/terms') ? 'active' : ''}`} onClick={() => setIsOpen(false)}>
                            Terms
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
